import api from "../api";
import ApiConstant from "../../constants/api.constants";

const GetDeliveryCashDetails = async (data: any) => {
    try {
        const CashDetails: any = await api
        .post(ApiConstant.GetDeliveryCashDetails, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error getting delivery cash details', error);
         });
        const response = CashDetails != null ? CashDetails : null;        
        return response;
    }
    catch
    {
        console.log('error getting delivery cash details');
        return false;
    }
}

const GetusersListCashhandover = async () => {  
    try {
        const userlist: any = await api
        .get(ApiConstant.GetusersListCashhandover)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error reading getting userlist data.', error);
         });
        const response = userlist != null ? userlist : null;        
        return response;
    }
    catch (e) {
        console.log('error reading getting userlist data.');
        return [];
    } 
};

const AddCashHandoverrequest = async (data: any) => {
    try {
        const request: any = await api
        .post(ApiConstant.addCashHandoverrequest, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error requesting Cash handover', error);
         });
        const response = request != null ? request : null;        
        return response;
    }
    catch
    {
        console.log('error requesting product quatitiy');
        return false;
    }
}

const GetuserlistSearch = async () => {  
    try {
        const userlist: any = await api
        .get(ApiConstant.GetuserlistSearch)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error reading getting userlist data.', error);
         });
        const response = userlist != null ? userlist : null;        
        return response;
    }
    catch (e) {
        console.log('error reading getting userlist data.');
        return [];
    } 
};


const GetStoreandAcceptedcash = async (data: any) => {
    try {
        const CashDetails: any = await api
        .post(ApiConstant.GetStoreandAcceptedcash, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error getting delivery cash details', error);
         });
        const response = CashDetails != null ? CashDetails : null;        
        return response;
    }
    catch
    {
        console.log('error getting delivery cash details');
        return false;
    }
}

const gethandoverrequests = async () => {  
    try {
        const requests: any = await api
        .get(ApiConstant.gethandoverrequests)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error getting handover request', error);
         });
        const response = requests != null ? requests : null;        
        return response;
    }
    catch (e) {
        console.log('error getting handover request');
        return [];
    } 
};

export const acceptcashhandover = async (id: number) => {
    try {
        const Accept = await api.put(ApiConstant.acceptcashhandover + id)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error accepting cash handover.', error);
         });
         const response = Accept != null ? Accept : null;        
         return response;
    } catch (e) {
        console.log('error accepting cash handover.');
        return [];
    } 
};

export const rejectcashhandover = async (id: number) => {
    try {
        const rejects = await api.put(ApiConstant.rejectcashhandover + id)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error accepting cash handover.', error);
         });
         const response = rejects != null ? rejects : null;        
         return response;
    } catch (e) {
        console.log('error accepting cash handover.');
        return [];
    } 
};

const getAllHandoverRequestsHistory = async () => {  
    try {
        const requests: any = await api
        .get(ApiConstant.getAllHandoverRequestsHistory)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error getting all request of user', error);
         });
        const response = requests != null ? requests : null;        
        return response;
    }
    catch (e) {
        console.log('error getting all request of user');
        return [];
    } 
};

const GetcashReport = async (data: any) => {
    try {
        const CashDetails: any = await api
        .post(ApiConstant.GetcashReport, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error getting cash Report', error);
         });
        const response = CashDetails != null ? CashDetails : null;        
        return response;
    }
    catch
    {
        console.log('error getting cash Report');
        return false;
    }
}


const GetAccountsCashDetails = async (data: any) => {
    try {
        const CashDetails: any = await api
        .post(ApiConstant.GetAccountsCashDetails, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error getting Accounts cash details', error);
         });
        const response = CashDetails != null ? CashDetails : null;        
        return response;
    }
    catch
    {
        console.log('error getting Accounts cash details');
        return false;
    }
}


const GetReceivedCashTrace = async (data: any) => {
    try {
        const CashDetails: any = await api
        .post(ApiConstant.GetReceivedCashTrace, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error getting Received cash details', error);
         });
        const response = CashDetails != null ? CashDetails : null;        
        return response;
    }
    catch
    {
        console.log('error getting Received cash details');
        return false;
    }
}

const GetHandovercashTrace = async (data: any) => {
    try {
        const CashDetails: any = await api
        .post(ApiConstant.GetHandovercashTrace, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error getting Handover cash details', error);
         });
        const response = CashDetails != null ? CashDetails : null;        
        return response;
    }
    catch
    {
        console.log('error getting Handover cash details');
        return false;
    }
}

export const GetDEPerformanceRatio = async (data: any) => {
  try {
    const result = await api.post(ApiConstant.getDeliveryExecutivePerformanceRatio, data);
    if (result && result.data) {
      return result.data;
    } else {
      console.warn("Empty response from API");
      return null;
    }
  } catch (error) {
    console.error("Error fetching Delivery Executive Performance Ratio:", error);
    return null;
  }
};


const DeliveryCashService = {
    GetDeliveryCashDetails,
    GetusersListCashhandover,
    AddCashHandoverrequest,
    GetuserlistSearch,
    GetStoreandAcceptedcash,
    gethandoverrequests,
    acceptcashhandover,
    rejectcashhandover,
    getAllHandoverRequestsHistory,
    GetcashReport,
    GetAccountsCashDetails,
    GetReceivedCashTrace,
    GetHandovercashTrace,
    GetDEPerformanceRatio
};

export default DeliveryCashService;
